(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template-combined-lock"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function() {
    
    const radioButtons = document.querySelectorAll('#AddToCartForm-product-template-combined input[type=radio][name=Variantenauswahl]');

    radioButtons.forEach(function(radioButton) {
      radioButton.addEventListener('change', function() {
        check_qty_for_minis(this.value);
      });
    });




   document.addEventListener('input', function(e) {
    if (e.target && e.target.id === 'Quantity-product-template-combined') {
      const maxval = parseInt(e.target.getAttribute('max'));
      const qtyval = parseInt(e.target.value);

      if (qtyval > maxval) {
        e.target.value = maxval;
      }
    }
  });
 });

// jQuery(document).ready(function() {


//     jQuery('#AddToCartForm-product-template-combined input[type=radio][name=Size],#AddToCartForm-product-template-combined input[type=radio][name^=Grö]').change(function() {	
// 		check_qty_for_minis(this.value);
// 	});


// 	jQuery('body').on('input','#Quantity-product-template-combined',function(){
// 		var obj = jQuery(this);
// 		var maxval = parseInt(obj.attr('max'));
// 		var qtyval = parseInt(obj.val());
// 		if(qtyval > maxval){
// 			obj.val(maxval);
// 		}
// 	});

// });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-combined-var2"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function() {
    
    const radioButtons = document.querySelectorAll('#AddToCartForm-product-template-combined input[type=radio][name=Variantenauswahl]');

    radioButtons.forEach(function(radioButton) {
      radioButton.addEventListener('change', function() {
        check_qty_for_minis(this.value);
      });
    });


  document.addEventListener('input', function(e) {
    if (e.target && e.target.id === 'Quantity-product-template-combined') {
      const maxval = parseInt(e.target.getAttribute('max'));
      const qtyval = parseInt(e.target.value);

      if (qtyval > maxval) {
        e.target.value = maxval;
      }
    }
  });

 });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-combined"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function() {
    
    const radioButtons = document.querySelectorAll('#AddToCartForm-product-template-combined input[type=radio][name=Variantenauswahl]');

    radioButtons.forEach(function(radioButton) {
      radioButton.addEventListener('change', function() {
        check_qty_for_minis(this.value);
      });
    });


  

  document.addEventListener('input', function(e) {
    if (e.target && e.target.id === 'Quantity-product-template-combined') {
      const maxval = parseInt(e.target.getAttribute('max'));
      const qtyval = parseInt(e.target.value);

      if (qtyval > maxval) {
        e.target.value = maxval;
      }
    }
  });

  //const quantityInput = document.getElementById('Quantity-product-template-combined');
  // if (quantityInput) {
  //   console.log("test input");
  //   quantityInput.addEventListener('input', function() {
  //     console.log("test input "+ this.value);
  //     const maxval = parseInt(this.getAttribute('max'));
  //     const qtyval = parseInt(this.value);

  //     if (qtyval > maxval) {
  //       this.value = maxval;
  //     }
  //   });
  // }

 });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-customized"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {

  const farbanzahl_radio = document.querySelector('input[type=radio][name=Farbanzahl]:checked');
  if(farbanzahl_radio) {
    cc_anzahl_change(farbanzahl_radio.value);
  } else {
    cc_anzahl_change('2 Farbtöne');
  }

  const farbanzahlRadios = document.querySelectorAll('input[type=radio][name=Farbanzahl]');
  farbanzahlRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      cc_anzahl_change(this.value);
    });
  });

});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-dropdown"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {


  document.addEventListener('input', function(e) {
    if (e.target && e.target.id === 'Quantity-product-template-dropdown') {
      const maxval = parseInt(e.target.getAttribute('max'));
      const qtyval = parseInt(e.target.value);

      if (qtyval > maxval) {
        e.target.value = maxval;
      }
    }
  });

  // const quantityInput = document.getElementById('Quantity-product-template-dropdown');

  // if (quantityInput) {
  //   quantityInput.addEventListener('input', function() {
  //     const maxval = parseInt(this.getAttribute('max'));
  //     const qtyval = parseInt(this.value);

  //     if (qtyval > maxval) {
  //       this.value = maxval;
  //     }
  //   });
  // }

 });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-dropdowncolors"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

  document.addEventListener('input', function(e) {
    if (e.target && e.target.id === 'Quantity-product-template-dropdown') {
      const maxval = parseInt(e.target.getAttribute('max'));
      const qtyval = parseInt(e.target.value);

      if (qtyval > maxval) {
        e.target.value = maxval;
      }
    }
  });

 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {

  const radioButtons = document.querySelectorAll('#AddToCartForm-product-template input[type=radio][name=Size],#AddToCartForm-product-template input[type=radio][name^=Grö]');

    radioButtons.forEach(function(radioButton) {
      radioButton.addEventListener('change', function() {
        check_qty_for_minis(this.value);
      });
    });

  document.addEventListener('input', function(e) {
    if (e.target && e.target.id === 'Quantity-product-template') {
      const maxval = parseInt(e.target.getAttribute('max'));
      const qtyval = parseInt(e.target.value);

      if (qtyval > maxval) {
        e.target.value = maxval;
      }
    }
  });

  // const quantityInput = document.getElementById('Quantity-product-template-dropdown');

  // if (quantityInput) {
  //   quantityInput.addEventListener('input', function() {
  //     const maxval = parseInt(this.getAttribute('max'));
  //     const qtyval = parseInt(this.value);

  //     if (qtyval > maxval) {
  //       this.value = maxval;
  //     }
  //   });
  // }

 });



// $(document).ready(function() {

//     $('#AddToCartForm-product-template input[type=radio][name=Size],#AddToCartForm-product-template input[type=radio][name^=Grö]').change(function() {	
// 		check_qty_for_minis(this.value);
// 	});


// 	// $('body').on('input','#Quantity-product-template',function(){
// 	// 	var obj = $(this);
// 	// 	var maxval = parseInt(obj.attr('max'));
// 	// 	var qtyval = parseInt(obj.val());
// 	// 	if(qtyval > maxval){
// 	// 		obj.val(maxval);
// 	// 	}
// 	// });
// });

// function check_qty_for_minis(value_to_check){
//     if(value_to_check == 'Mini zum Testen'){
//       $('.mini_message').show();
//       $('#AddToCartForm-product-template #Quantity-product-template').attr('max',1).val(1);
//       $('#AddToCartForm-product-template .js-qty__wrapper button').hide();
//     }
//     else
//     {
//       $('#AddToCartForm-product-template #Quantity-product-template').attr('max',1000);
//       $('#AddToCartForm-product-template .js-qty__wrapper button').show();
//       $('.mini_message').hide();
//     }
// }

  } catch(e) { console.error(e); }
})();
})();
